// FILE: /src/Components/Dashboard/UsageTracker.js (FULLY UPDATED & CORRECTED)

import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Tooltip, Button } from 'antd';
import { formatBytes } from '../../utils/formatters';

const UsageBar = ({ label, used, limit, unit, isStorage = false }) => {
    const percentage = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;
    const isExceeded = used > limit;

    const usedFormatted = isStorage ? formatBytes(used) : used.toLocaleString();
    const limitFormatted = limit > 0 ? (isStorage ? formatBytes(limit) : limit.toLocaleString()) : 'Unlimited';

    return (
        <div className="text-xs">
            <Tooltip title={`${usedFormatted} / ${limitFormatted} Used`}>
                <div>
                    <div className="flex justify-between mb-1 font-semibold">
                        <span className="text-sidebar-text">{label}</span>
                        <span className={isExceeded ? 'text-red-400' : 'text-sidebar-active-text'}>
                            {usedFormatted} / {limitFormatted}
                        </span>
                    </div>
                    <div className="w-full bg-sidebar-active-bg rounded-full h-1.5">
                        <div
                            className={`h-1.5 rounded-full transition-all duration-500 ${isExceeded ? 'bg-red-500' : 'bg-brand-progress'}`}
                            style={{ width: `${percentage}%` }}
                        ></div>
                    </div>
                </div>
            </Tooltip>
        </div>
    );
};


export default function UsageTracker() {
    const navigate = useNavigate();
    const { subscription } = useSelector(state => state.subscription);
    const { totalSize } = useSelector(state => state.library);

    const handleBuyMore = () => {
        navigate('/Dashboard/AccountSetting');
    };

    if (!subscription || !subscription.plan) {
        return null;
    }

    // --- START: THIS IS THE CORRECT, SIMPLIFIED LOGIC ---
    const planLimits = subscription.plan;

    // Directly use the pre-calculated total limits from the backend.
    const totalAiLimit = planLimits.ai_credits_total_limit || 0;
    const totalStorageLimitBytes = (planLimits.storage_gb_limit || 0) * 1024 * 1024 * 1024;

    const aiUsed = subscription?.ai_credits_consumed ?? 0;
    const storageUsedBytes = totalSize || 0;
    // --- END: THIS IS THE CORRECT, SIMPLIFIED LOGIC ---

    return (
        <div className="p-4 mx-2 mb-2 border-t border-sidebar-border space-y-4">
            <UsageBar
                label="AI Credits"
                used={aiUsed}
                limit={totalAiLimit}
                unit="Credits"
            />
            <UsageBar
                label="Brand Storage"
                used={storageUsedBytes}
                limit={totalStorageLimitBytes}
                unit="Bytes" // The unit is now Bytes for accurate formatting
                isStorage={true} // Flag to use formatBytes
            />
            <Button
                type="primary"
                block
                onClick={handleBuyMore}
                className="bg-brand-primary hover:bg-brand-primary-hover border-none mt-2"
            >
                Buy Add-ons
            </Button>
        </div>
    );
}